import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var initForm = {
  orderNo: '',
  goodsName: '',
  consumerName: '',
  phoneNumber: '',
  nickname: '',
  placePlatform: '',
  expressNumber: '',
  goodsModel: '',
  orderStatus: 6,
  storeName: '',
  orderTimeRange: {
    start: '',
    end: ''
  }
};
import { cloneDeep } from 'lodash';
export default {
  data: function data() {
    var _this = this;

    return {
      initForm: initForm,
      form: cloneDeep(initForm),
      request: {
        api: 'orders',
        params: cloneDeep(initForm),
        parser: function parser(res) {
          _this.records = res.records;
          return res;
        }
      },
      records: []
    };
  },
  methods: {
    handleSelectionChange: function handleSelectionChange() {},
    handleSearch: function handleSearch(values) {
      this.$set(this.request, 'params', values);
      this.$refs.baseTable.loadData();
    },
    download: function download() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var columns, data, res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                columns = [{
                  label: '订单号',
                  prop: 'orderId'
                }, {
                  label: '商品ID',
                  prop: 'goodsNo'
                }, {
                  label: '商品名称',
                  prop: 'goodsName'
                }, {
                  label: '订购数量',
                  prop: 'goodsCount'
                }, {
                  label: '下单时间',
                  prop: 'orderTime'
                }, {
                  label: '要炼价',
                  prop: 'goodsAmount'
                }, {
                  label: '订单金额',
                  prop: 'orderAmount'
                }, {
                  label: '结算金额',
                  prop: 'orderAmount'
                }, {
                  label: '余额支付',
                  prop: 'balancePay'
                }, {
                  label: '应付金额',
                  prop: 'orderAmount'
                }, {
                  label: '订单状态',
                  prop: 'orderStatus'
                }, {
                  label: '下单帐号',
                  prop: 'nickname'
                }, {
                  label: '客户姓名',
                  prop: 'consigneeName'
                }, {
                  label: '客户地址',
                  prop: 'consigneeAddress'
                }, {
                  label: '联系电话',
                  prop: 'consigneePhone'
                }, {
                  label: '订单备注',
                  prop: 'buyerRemark'
                }, {
                  label: '发票类型',
                  prop: 'invoiceType'
                }, {
                  label: '发票抬头',
                  prop: 'invoiceTitle'
                }, {
                  label: '发票内容',
                  prop: 'invoiceContent'
                }, {
                  label: '纳税人识别号',
                  prop: 'taxpayerIdNumber'
                }, {
                  label: '名称（个人）',
                  prop: 'invoiceTitleType'
                }, {
                  label: '单位地址',
                  prop: 'taxpayerAddress'
                }, {
                  label: '单位电话',
                  prop: 'taxpayerPhone'
                }, {
                  label: '开户银行',
                  prop: 'invoiceBankName'
                }, {
                  label: '银行账号',
                  prop: 'invoiceBankAccount'
                }, {
                  label: '商家备注',
                  prop: 'storeRemark'
                }, {
                  label: '商家备注等级（等级1-5为由高到低）',
                  prop: 'storeRemarkLevel'
                }, {
                  label: '运费金额',
                  prop: 'deliveryAmount'
                }, {
                  label: '付款确认时间',
                  prop: 'payTime'
                }, {
                  label: '货号',
                  prop: 'goodsModel'
                }, {
                  label: '订单完成时间',
                  prop: 'completeTime'
                }];
                data = [];
                _context2.next = 4;
                return _this2.$api.exportOrders(_objectSpread(_objectSpread({}, _this2.form), {}, {
                  pageSize: 999999
                }));

              case 4:
                res = _context2.sent;
                res.records.forEach( /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(v) {
                    var goodsParams, params, orderStatusStr;
                    return regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            goodsParams = {};
                            v.goodsItemList.forEach(function (e) {
                              goodsParams = _objectSpread({}, e);
                            });
                            params = {};
                            params = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, v), v.consigneeInfo), v.invoiceInfo), goodsParams);

                            _this2.$set(params, 'consigneeAddress', v.consigneeInfo.consigneeProvince + v.consigneeInfo.consigneeCity + v.consigneeInfo.consigneeDistrict + v.consigneeInfo.consigneeDetails);

                            orderStatusStr = _this2.dict.orderStatus.filter(function (e) {
                              return e.value == v.orderStatus;
                            });

                            _this2.$set(params, 'orderStatus', orderStatusStr[0].label);

                            _this2.$set(params, 'invoiceType', v.invoiceType == 1 ? '普通电子发票' : v.invoiceType == 2 ? '增值税专用发票' : v.invoiceType == 3 ? '不开发票' : '');

                            _this2.$set(params, 'invoiceContent', v.invoiceInfo.invoiceContent == 1 ? '商品明细' : v.invoiceInfo.invoiceContent == 2 ? '商品类型' : '');

                            _this2.$set(params, 'invoiceTitleType', v.invoiceInfo.invoiceTitleType == 1 ? '个人' : v.invoiceInfo.invoiceTitleType == 2 ? '公司' : '');

                            if (res.payWay === 3) {
                              _this2.$set(params, 'balancePay', res.orderAmount);
                            }

                            data.push(params);

                          case 12:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }());

                _this2.xlsxExport(columns, data, '已取消订单');

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  }
};